export default __webpack_public_path__ + "static/media/food-plate.36e75b72.jpg";